// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { DasComponent } from './das/das.component';
import { DesComponent } from './des/des.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { CourierTcsComponent } from './courier-tcs/courier-tcs.component';
// import { DesfFinalLetterComponent } from './desf-final-letter/desf-final-letter.component';
// import { CourseraAdminComponent } from './coursera-admin/coursera-admin.component';
// import { PaymentComponent } from './payment/payment.component';
// import { EcoursesComponent } from './ecourses/ecourses.component';
// import { DesVerificationComponent } from './des-verification/des-verification.component';
// import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
// import { NotificationsListComponent } from './notifications-list/notifications-list.component';
// import { ApplicationSchedulingComponent } from './application-scheduling/application-scheduling.component';
// import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
// import { AuthModule } from './auth/auth.module';

@NgModule({
	declarations: [CourierTcsComponent],
	exports: [],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		// InternationalPhoneNumberModule,
		CoreModule,
		PartialsModule,
		// AuthModule,
	],
	providers: []
})
export class PagesModule {
}
